import uiRouter from '@uirouter/angularjs';

export const GridScrollModule = angular
    .module('app.directives.gridScroll', [uiRouter])
    .directive('gridScroll', ($window, $timeout, $rootScope, $state, $document) => {
        return {
            link: (scope, element, attrs) => {
                var cutoff = 0;
                var $$document = angular.element($document);
                var $$window = angular.element($window);
                var $gridWrap = angular.element('.vln-grid__wrap');
                var $gridHeader;
                let pageBackground;
                let descriptionContainer;

                // a comma-separated set of selectors for fixed elements whose total height
                // becomes top offset of grid header (i.e. '.page__header, .page__status')
                var offsetSelectors = attrs.gridScrollOffset.split(',').map(s => s.trim());

                // set this to use multiple grid headers (i.e. '.tc-display_head, .vln-grid__header')
                var headerSelector = attrs.gridScrollHeaders || '.tc-display_thead';

                var watcher = attrs.gridScrollWatch;
                var removeScopeListener = $rootScope.$on('storefrontSliderDirective:update', resizeManager);

                if (watcher) {
                    scope.$watch(watcher, () => $timeout(resizeManager));
                }

                const UI_SETTLING_DELAY = 100;
                $timeout(() => {
                    // tc-grid header doesn't exist until first render
                    $gridHeader = angular.element(headerSelector);

                    $$window.on('scroll', scrollManager);
                    $$window.on('resize orientationchange', resizeManager);

                    resizeManager();
                }, UI_SETTLING_DELAY);

                scope.$on('$destroy', () => {
                    $$window.off('scroll', scrollManager);
                    $$window.off('resize orientationchange', resizeManager);
                    removeScopeListener();
                });

                function scrollManager() {
                    $gridHeader = angular.element(headerSelector);
                    var currScroll = $$document.scrollTop();
                    let cutoffStart = ($state.current.name === 'category.detail') ?
                        cutoff + pageBackground + descriptionContainer : cutoff;
                    let cutoffStop = cutoffStart + ($gridWrap.height() - $gridHeader.height());

                    let pastCutoffStart = currScroll > cutoffStart;
                    let pastCutoffStop = currScroll >= cutoffStop;

                    if ($$window.height() === $$document.height()) {
                        return;
                    }

                    $gridWrap.toggleClass('vln-grid--fixed-header', pastCutoffStart);

                    if (pastCutoffStart) {
                        $gridHeader.css({
                            top: getHeaderOffset(),
                            width: $gridWrap.width()
                        });

                        $gridHeader.toggleClass('scrollup', pastCutoffStop);
                    } else {
                        $gridHeader.css({
                            top: '',
                            width: ''
                        });
                    }
                }

                function getHeaderOffset() {
                    let headerOffset = 0;

                    offsetSelectors.forEach((selector) => {
                        headerOffset += angular.element(selector).outerHeight();
                    });

                    return headerOffset;
                }

                function getCutoff($el) {
                    return $el.offset().top - getHeaderOffset();
                }

                function resizeManager() {
                    cutoff = getCutoff($gridWrap);
                    if ($state.current.name === 'category.detail') {
                        pageBackground = angular.element('.page__background').outerHeight();
                        descriptionContainer = angular.element('.description').outerHeight();
                    }

                    if ($gridHeader) {
                        $gridWrap.css('padding-top', $gridHeader.height());
                        scrollManager();
                    } else {
                        $gridWrap.css('padding-top', '40px');
                    }
                }
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/gridScroll.directive.js